package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

// As per backend, none of String fields will be null
@Serializable
@JsExport
data class AccountUser(
    val email: String,
    val firstName: String,
    val lastName: String,
    val userId: String,
    val customerId: String,
    val postalCode: String? = null,
    val phoneNumber: String? = null,
    val facebookId: String? = null,
    val googleId: String? = null,
    val appleId: String? = null,
    val guestUser: Boolean,
    val emailVerified: Boolean,
    val requiresEmailVerification: Boolean,
    val requiresPersonalization: Boolean,
    val birthDate: String? = null,
    val gender: String? = null,
    val isWalmartAccount: Boolean? = null,
    val isWalmartDoNotSell: Boolean? = null,
    val isWalmartDoNotShare: Boolean? = null,
    val isWalmartInvalidLocation: Boolean? = null,
    val walmartAccountStatus: String? = null
)